export const chunkify = (array, chunkSize) =>
  Array(Math.ceil(array.length / chunkSize))
    .fill(null)
    .map((_, index) => index * chunkSize)
    .map((begin) => array.slice(begin, begin + chunkSize));

export const buildPayeeRenderData = (payeeSpending, payeesPerPage) => {
  const spendingExcludingTransactions = payeeSpending.map((datum, index) => ({
    payee: datum.groupKey,
    amount: -datum.total,
    currency: datum.currency,
    index,
  }));

  spendingExcludingTransactions.length = 5;
  return chunkify(spendingExcludingTransactions, payeesPerPage);
};

export const getMonthlyChartColors = (isIncome, theme) => {
  const componentTheme = isIncome ? theme?.components?.income : theme?.components?.spendingOverTime;
  return {
    positiveDefault: componentTheme?.positiveDefault,
    positiveDimmed: componentTheme?.positiveDimmed,
    negativeDefault: componentTheme?.negativeDefault,
    negativeDimmed: componentTheme?.negativeDimmed,
    tooltipBullet: componentTheme?.positiveDefault,
  };
};

export const getOverTimeReportRoute = (isIncome, index?: number | null) =>
  `/reports/${isIncome ? 'income' : 'spending'}/by-none/over-time${index != null ? `?selectMonth=${index}` : ''}`;

export const isMonthlyDataEmpty = (monthlyData) =>
  monthlyData.every((data) => data.txns.size === 0);
